import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=f3b05bb6&"
import script from "./customerList.vue?vue&type=script&lang=ts&"
export * from "./customerList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports